// TODO: To move the corresponding stuff to the business layer.
import { useState } from 'react';

import Urls from '../../../../../constants/Urls';
import http from '../../../../../services/HttpService';
import LocalStorageService from '../../../../../services/local-storage-service/LocalStorageService';
import UrlUtils from '../../../../../utils/url-utils/UrlUtils';

import { SATURATION } from 'business/highDemand';
import { highDemandAdapter } from 'business/highDemand/infra/adapters/highDemand.adapter';
import { STORE_STATUS_INPUT_DTO } from 'business/highDemand/infra/core';

import { operationalStateTurboHandler } from 'business/highDemand/infra';

import type { SeverityTimes, StoreStateByHDB } from 'business/highDemand';

const SEVERITY_TIMES: SeverityTimes = {
  superHigh: 0,
  high: 0,
  regular: 0,
  low: 0,
};

export function useFetchStoreStatus() {
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [stores, setStores] = useState<StoreStateByHDB[]>([]);
  const [severityTimes, setSeverityTimes] = useState(SEVERITY_TIMES);

  const clearState = () => {
    setIsError(false);
    setIsSuccess(false);
    setStores([]);
  };
  const { getStoreStatusDetail } = operationalStateTurboHandler();

  const fnFetch = () => {
    setIsLoading(true);
    setIsError(false);
    setIsSuccess(false);
    const baseUrl = LocalStorageService.getBaseUrl();
    const uriSaturationListByStoreWithSeverityTimes = UrlUtils.replaceUrlParams(
      Urls.SATURATION_LIST_BY_STORE_WITH_SEVERITY_TIMES,
    );
    const uriCheckStoreEligibilityForFastOperation = UrlUtils.replaceUrlParams(
      Urls.CHECK_STORE_ELIGIBILITY_FOR_FAST_OPERATION,
    );
    setTimeout(async () => {
      let localIsSuccess = false;
      try {
        localIsSuccess = true;
        const storesDetail = await getStoreStatusDetail();
        const { data } = await http.get(
          `${baseUrl}${uriSaturationListByStoreWithSeverityTimes}`,
        );
        const stores = data.stores.map(store => {
          const _s = storesDetail.find(item => item.id === store.store_id);
          return {
            ...store,
            status: STORE_STATUS_INPUT_DTO[_s!.status],
            cta: _s?.ctaType,
            isTurbo: _s?.isTurbo ?? false,
          };
        });
        setSeverityTimes(
          Object.fromEntries(
            Object.entries(data['severity_times']).map((item: any) => [
              highDemandAdapter.toModelSaturation(item[0]),
              item[1].extra_minutes,
            ]),
          ),
        );
        const storeIds = data.stores.map(({ store_id }) => store_id);
        const { data: storesForEligibilityFastOperation } = await http.post(
          `${baseUrl}${uriCheckStoreEligibilityForFastOperation}`,
          storeIds,
        );
        setStores(
          stores.map(item => ({
            id: item.store_id,
            name: item.name,
            address: item.address,
            status: item.status,
            cta: item.cta,
            isTurbo: item.isTurbo,
            saturated: (() => {
              if (item.is_from_occ_process) return SATURATION.fastFromOCC;
              else if (item.is_fast_operation) return SATURATION.fast;
              return highDemandAdapter.toModelSaturation(item.saturated);
            })(),
            isEligibleForFastOperation:
              storesForEligibilityFastOperation.find(
                _s => _s.store_id === item.store_id,
              )?.is_eligible_for_fast_operation ?? false,
          })),
        );
      } catch (err) {
        localIsSuccess = false;
      } finally {
        setIsLoading(false);
        localIsSuccess ? setIsSuccess(true) : setIsError(true);
      }
    }, 300);
  };

  return {
    isError,
    isSuccess,
    isLoading,
    fnFetch,
    stores,
    severityTimes,
    clearState,
  };
}
